import { useQuery } from 'react-query';
import { createOnboardingCompletion } from 'modules/api/digitalServices/onboarding-completion.service';

export interface OnboardingStatus {
  isCompleted: boolean;
  onboardRedirectUrl?: string;
}

export function useCreateOnboarding(email: string, enabled = true, retry = 0) {
  return useQuery<OnboardingStatus>(
    ['createOnboard', email],
    async (): Promise<OnboardingStatus> => {
      if (!email) {
        throw new Error('Email is required');
      }
      const res = await createOnboardingCompletion(email);
      return res.data;
    },
    {
      enabled,
      retry,
      onError: (err) => {
        console.warn('Error creating onboarding:', err);
      },
    },
  );
}
